import { render, staticRenderFns } from "./ConsumosWrapper.vue?vue&type=template&id=3ce435f9&scoped=true"
import script from "./ConsumosWrapper.vue?vue&type=script&lang=js"
export * from "./ConsumosWrapper.vue?vue&type=script&lang=js"
import style0 from "./ConsumosWrapper.vue?vue&type=style&index=0&id=3ce435f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce435f9",
  null
  
)

export default component.exports